module.exports = __webpack_public_path__ + "static/media/downloadPrApple.28ae7ec6.svg";